import { BaseFieldClass } from './baseField.class'

import { IFilterValueType } from '@/types/sections.type'
import { IDataField } from '@/types/serverField.type'

export class DataFieldClass extends BaseFieldClass {
  declare fieldValue: IDataField['Value']
  declare initialValue: IDataField['Value']

  constructor (field: IDataField) {
    super(field)

    const value = field.Value ?? field.DefaultValue
    this.initialValue = this.prepareValue(value)
    this.fieldValue = this.prepareValue(value)
  }

  prepareValue (value: IDataField['Value']): IDataField['Value'] {
    return value ?? ''
  }

  getValue (): Record<string, IDataField['Value']> {
    return {
      [this.name]: this.fieldValue
    }
  }

  appendToFormData (formData: FormData): void {
    formData.append(this.name, String(this.fieldValue ?? ''))
  }

  getFilterValue (): IFilterValueType['Value'] {
    return this.fieldValue
  }
}
